import "./LoginBackground.css";

// left (%), tamanho (px), duração (s), atraso (s), deriva horizontal (px)
const DOTS = [
  [6, 4, 19, 0, 30],
  [14, 3, 24, 6, -20],
  [22, 5, 21, 2, 40],
  [31, 3, 26, 11, -30],
  [40, 4, 18, 4, 20],
  [48, 3, 23, 9, -40],
  [57, 5, 20, 1, 30],
  [64, 3, 27, 13, -20],
  [72, 4, 22, 5, 40],
  [80, 3, 25, 8, -30],
  [88, 5, 19, 3, 20],
  [94, 3, 24, 12, -40],
];

export default function LoginBackground() {
  return (
    <div className="lb-root" aria-hidden="true" data-testid="login-background">
      <div className="lb-blob lb-blob-1" />
      <div className="lb-blob lb-blob-2" />
      <div className="lb-blob lb-blob-3" />
      <div className="lb-grid" />

      <svg className="lb-waves" viewBox="0 0 800 900" preserveAspectRatio="xMidYMid slice">
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <path
            key={i}
            className="lb-wave"
            style={{ animationDelay: `${-i * 2}s`, animationDuration: `${12 + i * 2}s` }}
            d={`M -100 ${140 + i * 130} Q 200 ${40 + i * 130}, 400 ${140 + i * 130} T 900 ${140 + i * 130}`}
          />
        ))}
      </svg>

      {DOTS.map(([left, size, dur, delay, drift]) => (
        <span
          key={`${left}-${delay}`}
          className="lb-dot"
          style={{
            left: `${left}%`,
            width: size,
            height: size,
            "--lb-d": `${dur}s`,
            "--lb-delay": `${delay}s`,
            "--lb-drift": `${drift}px`,
          }}
        />
      ))}
    </div>
  );
}
